import { StoreRemoveIcon } from './StoreRemoveIcon';

/**
 * author: Dylan Oli
 * id FB5C0EA4-DAA2-4415-856F-2A4E6FA78BA5
 * name store-remove
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-remove.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreDeleteIcon = StoreRemoveIcon;
export default StoreDeleteIcon